import { NodeSpec, Node } from 'prosemirror-model';

export const mentionNode: NodeSpec = {
	group: "inline",
	inline: true,
	atom: true,

	attrs: {
		id: { default: "" },
		name: { default: "" },
		email: { default: "" }
	},

	selectable: false,
	draggable: false,

	toDOM: (node: Node) => {
		return [
			"span",
			{
				"data-mention-id": node.attrs.id,
				"data-mention-name": node.attrs.name,
				"data-mention-email": node.attrs.email,
				class: "prosemirror-mention-node"
			},
			"@" + node.attrs.name || node.attrs.email
		];
	},

	parseDOM: [
		{
			// match tag with following CSS Selector
			tag: "span[data-mention-id][data-mention-name][data-mention-email]",

			getAttrs: (dom: string | HTMLElement) => {
				if (typeof dom === 'string') return { id: "", name: "", email: "" };

				const id = dom.getAttribute("data-mention-id");
				const name = dom.getAttribute("data-mention-name");
				const email = dom.getAttribute("data-mention-email");

				return { id, name, email };
			}
		}
	]
};

export const tagNode: NodeSpec = {
	group: "inline",
	inline: true,
	atom: true,

	attrs: {
		tag: { default: "" }
	},

	selectable: false,
	draggable: false,

	toDOM: (node: Node) => {
		return [
			"span",
			{
				"data-tag": node.attrs.tag,
				class: "prosemirror-tag-node"
			},
			"#" + node.attrs.tag
		];
	},

	parseDOM: [
		{
			// match tag with following CSS Selector
			tag: "span[data-tag]",

			getAttrs: (dom: string | HTMLElement) => {
				if (typeof dom === 'string') return { tag: "" };

				const tag = dom.getAttribute("data-tag");
				return { tag };
			}
		}
	]
};
